var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control" },
    [
      _c("vue-ctk-date-time-picker", {
        attrs: {
          id: _vm.id,
          locale: _vm.locale,
          format: _vm.format,
          label: "",
          formatted: _vm.format,
          color: "#ff7f2a",
          "auto-close": true,
          "only-date": true,
          "no-label": true,
          "no-header": true,
          "no-shortcuts": true,
          "no-button": true,
          "no-button-now": true,
          "first-day-of-week": 1,
          "min-date": _vm.min || null,
          "max-date": _vm.max,
          "disabled-weekly": _vm.weekDisabled,
          range: false,
        },
        model: {
          value: _vm.week,
          callback: function ($$v) {
            _vm.week = $$v
          },
          expression: "week",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }